import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

const client = createClient('/rest/operator-api/charging-stations');

export const generateCredentials: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(client, {
  pattern: '/{chargingStationId}/generate-credentials',
  permissionId: commandPermissions.GENERATE_CREDENTIALS
});
